import React, { Component } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import './Layout.css';
import './LayoutOverrides.css';

export class Layout extends Component {
    state = {
        sidebarCollapsed: false,
        currentPath: window.location.pathname
    }

    componentDidMount() {
        this._isMounted = true;
        // Use a flag to track if we added the class
        this.addedHasSidebar = !document.body.classList.contains('has-sidebar');

        const savedState = localStorage.getItem('sidebarCollapsed');
        if (savedState !== null) {
            this.setState({ sidebarCollapsed: JSON.parse(savedState) });
            document.body.classList.toggle('sidebar-collapsed', JSON.parse(savedState));
        }
        document.body.classList.add('has-sidebar');

        window.addEventListener('storage', this.handleStorageChange);
        window.addEventListener('popstate', this.handleRouteChange);
    }

    handleRouteChange = () => {
        if (this._isMounted) {
            this.setState({ currentPath: window.location.pathname });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        // Only remove has-sidebar if we were the ones who added it
        if (this.addedHasSidebar) {
            document.body.classList.remove('has-sidebar', 'sidebar-collapsed');
        }
        window.removeEventListener('storage', this.handleStorageChange);
        window.removeEventListener('popstate', this.handleRouteChange);
    }

    handleStorageChange = (e) => {
        if (e.key === 'sidebarCollapsed' && this._isMounted) {
            const collapsed = JSON.parse(e.newValue);
            this.setState({ sidebarCollapsed: collapsed });
            document.body.classList.toggle('sidebar-collapsed', collapsed);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.sidebarCollapsed !== this.state.sidebarCollapsed) {
            document.body.classList.toggle('sidebar-collapsed', this.state.sidebarCollapsed);
        }
    }

    render() {
        return (
            <>
                <Sidebar />
                <div className="main-content">
                    <TopBar currentPath={this.state.currentPath} />
                    <div className="page-content">
                        {this.props.children}
                    </div>
                </div>
            </>
        );
    }
}

export default Layout;